// Converts hexidecimal string to rgb array
export const hex2RGB = hex => {
  const regex = RegExp(`(?:[a-f0-9]{1,${hex.replace('#', '').length / 3}})`, 'gi')
  return hex.match(regex).map(v => parseInt(v, 16))
}

// Returns a 2 decimal point float
export const toFloat = val => parseFloat(val.toFixed(2))



// WEBPACK FOOTER //
// ./src/helpers.js